export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_ROOT = process.env.REACT_APP_API_URL;
export const SOCKET_ROOT = process.env.REACT_APP_SOCKET_URL;
export const LOCALES_ROOT = process.env.REACT_APP_LOCALE_URL;
export const SAMPLE_FILES_ROOT = process.env.REACT_APP_SAMPLE_FILES_URL;
export const UPLOADS_ROOT = process.env.REACT_APP_UPLOAD_URL;
export const UPLOADS_API_ENDPOINT = process.env.REACT_APP_UPLOAD_API_URL;
export const SERVER_IS_NORWAY = process.env.REACT_APP_SERVER_IS_NORWAY;
export const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME;

export const redirectToAppStore = (event, store) => {
    event.preventDefault();
    window.open(store === 'apple' ? process.env.REACT_APP_APPLE_STORE_URL : process.env.REACT_APP_GOOGLE_PLAY_STORE_URL, '_blank');
}

export const getUploadedFileURL = id => `${UPLOADS_API_ENDPOINT}/${id}`;

export const MICROSOFT_AUTHENTICATOR_ANDROID = process.env.REACT_APP_MICROSOFT_AUTHENTICATOR_ANDROID;
export const MICROSOFT_AUTHENTICATOR_IOS = process.env.REACT_APP_MICROSOFT_AUTHENTICATOR_IOS;
export const GOOGLE_AUTHENTICATOR_ANDROID = process.env.REACT_APP_GOOGLE_AUTHENTICATOR_ANDROID;
export const GOOGLE_AUTHENTICATOR_IOS = process.env.REACT_APP_GOOGLE_AUTHENTICATOR_IOS;

const __config__ = {
    BASE_URL,
    API_ROOT,
    SOCKET_ROOT,
    LOCALES_ROOT,
    SAMPLE_FILES_ROOT,
    UPLOADS_ROOT,
    UPLOADS_API_ENDPOINT,
    SERVER_IS_NORWAY,
    redirectToAppStore,
    getUploadedFileURL,
    PROJECT_NAME
};

export default __config__;